import { cn } from "@/lib";
import { forwardRef, JSX } from "react";
import TextField from "../textField";

interface IProps {
  items: string[];
  onSelect: (item: string) => void;
  searchable?: boolean;
  onSearch?: (query: string) => void;
  searchValue?: string;
  searchPlaceHolder?: string;
  searchIconStart?: JSX.Element;
  searchIconEnd?: JSX.Element;
}

const DropdownList = forwardRef<HTMLUListElement, IProps>(
  (
    {
      items,
      onSelect,
      searchable,
      onSearch,
      searchValue = "",
      searchPlaceHolder,
      searchIconStart,
      searchIconEnd,
    },
    ref,
  ) => {
    return (
      <div className="shadow-main absolute top-14 z-20 min-w-full overflow-hidden rounded-md bg-white">
        {searchable && onSearch && (
          <div className="p-2">
            {/* <input
              type="text"
              value={searchValue}
              onChange={(e) => onSearch((e.target as HTMLInputElement).value)}
              className="focus:border-primary-main w-full rounded-md border border-gray-300 p-2 focus:outline-none"
              placeholder="Search..."
              autoFocus
            /> */}
            <TextField
              iconStart={searchIconStart}
              aria-label="search"
              inputClassName={cn("tracking-widest h-10 ")}
              placeholder={searchPlaceHolder || "جست و جو کنید"}
              iconEnd={searchIconEnd}
              hasShadow
              inputMode="search"
              onChange={(e) => onSearch((e.target as HTMLInputElement).value)}
              value={searchValue}
            />
          </div>
        )}
        <ul ref={ref} className="no-scrollbar max-h-60 overflow-y-auto py-1">
          {items.length > 0 ? (
            items.map((item, idx) => (
              <li
                key={idx}
                onClick={() => onSelect(item)}
                className={cn(
                  "hover:text-secondary-main w-full cursor-pointer p-3 transition-colors",
                )}
              >
                {item}
              </li>
            ))
          ) : (
            <li className="p-3 text-center text-gray-500">No results found</li>
          )}
        </ul>
      </div>
    );
  },
);

DropdownList.displayName = "DropdownList";

export default DropdownList;
